import React, { Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Header } from "@/components/Header";
import { HomePage } from "@/components/HomePage";
import { Footer } from "@/components/Footer";
import { directWhatsAppUrl } from "@/hooks/useWhatsAppMessage";

const PrivacyPolicyPage = React.lazy(() => import("@/components/PrivacyPolicyPage").then(m => ({ default: m.PrivacyPolicyPage })));
const TermsOfUsePage = React.lazy(() => import("@/components/TermsOfUsePage").then(m => ({ default: m.TermsOfUsePage })));

function App() {
  return (
    <div className="app-shell" data-testid="app-shell">
      <BrowserRouter>
        <Header />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
            <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
          </Routes>
        </Suspense>
        <Footer />
        <a className="floating-whatsapp" href={directWhatsAppUrl()} data-testid="floating-whatsapp-button" aria-label="Chamar no WhatsApp">
          <MessageCircle size={26} aria-hidden="true" />
        </a>
      </BrowserRouter>
    </div>
  );
}

export default App;